<template>
    <form @submit.prevent="onSubmit">
        <div class="modal-main">
            <h3>Settings</h3>
            <app-input id="name"
                       label="Change name"
                       name="name"
                       v-validate="'required|latin|checkLatinSymbol|min:1|max:100'"
                       v-model="form.tabName"
                       type="text">
            </app-input>

            <div class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Display:</h4>
                <div v-if="!isFetching">
                    <switch-button id="display"
                                   v-bind:checked.sync="form.display">
                    </switch-button>
                </div>
                <div v-else v-spinner></div>
            </div>
        </div>
        <div class="form-footer">
            <button class="primary-btn btn-center"
                    type="submit"
                    :disabled="!formValid || formPristine"
                    v-spinner="isLoading">Apply
            </button>
        </div>
    </form>
</template>

<script>
    import * as _ from 'lodash';
    import { mapGetters, mapActions } from 'vuex';
    import { FormMixin } from '@/mixins/FormMixin';
    import SpinnerDirective from '@/directives/SpinnerDirective';

    export default {
        name: 'SettingsModal',
        components: {
            AppInput: () => import('@/components/controls/AppInput'),
            SwitchButton: () => import('@/components/controls/SwitchButton')
        },
        directives: { SpinnerDirective },
        mixins: [FormMixin],
        data() {
            return {
                form: {
                    tabName: null,
                    display: false
                },
                isLoading: false,
                isFetching: false,
                notificationMsg: null
            }
        },
        computed: {
            ...mapGetters([
                'schoolId',
            ])
        },
        methods: {
            ...mapActions([
                'createSuccessNotification'
            ]),
            onSubmit() {
                if (!this.isLoading) {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.isLoading = true;
                            this.useService(this.schoolId, this.form)
                                .then(() => {
                                    this.$emit('submit');
                                    this.createSuccessNotification(this.notificationMsg);
                                })
                            .finally(() => this.isLoading = false);
                        }
                    });
                }
            },
            // the methods will be overwritten from inherited component
            useService() {
            },
            prefill() {
            }
        },
        created() {
            this.isFetching = true;
            this.prefill(this.schoolId)
                .then(({ tabName, displayTab }) => {
                    this.form.tabName = tabName;
                    this.form.display = displayTab;
                    this.formCopy = _.clone(this.form);
                })
                .finally(() => this.isFetching = false);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals/SettingsModal.vue